<div class="replace-matcard">
  <h1 class="cursorDefault">{{wagon?.title}}</h1>
  <div>
    <mat-form-field class="margin-right w-350">
      <mat-label>{{wagon?.dropDownPlaceholder}}</mat-label>
      <mat-select disableOptionCentering="true" (selectionChange)="changeProject($event.value)"
        [(value)]="selectedProjectId">
        <mat-option class="select-without-checkbox" *ngFor="let project of projects" [value]="project.id">
          {{project.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button class="color" [disabled]="selectedProjectId < 1" (click)="createWagon()">
      <mat-icon class="add">add_box</mat-icon>{{wagon?.addButton}}
    </button>
  </div>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource">

      <!-- wagonTypeName Column -->
      <ng-container matColumnDef="wagonName">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{wagon?.col1Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.name}}</span>
        </td>
      </ng-container>

      <!-- wagonTypeDescription Column -->
      <ng-container matColumnDef="wagonDescription">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{wagon?.col2Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.description}}</span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="wagonActions">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{wagon?.col3Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <mat-icon class="openCell" title="{{wagon?.action1}}" (click)="openCellEdit(element.id)">edit</mat-icon>
          <mat-icon class="openCell" title="{{wagon?.action2}}" (click)="openVariantList(element.id)">list</mat-icon>
          <mat-icon class="delete" title="{{wagon?.action4}}" (click)="showDeleteDialog(element.id)"> cancel</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row-effect">></tr>
    </table>
  </div>
</div>
<hr class="line">